import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { take, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private http: HttpClient, private afs: AngularFirestore) {}

  sendNotifications(d) {
    this.http.post(`${environment.apiUrl}/notify`, d).subscribe(
      (res) => {},
      (e) => console.error(e)
    );
  }

  saveNotification(uid, fuid, m, dn, p) {
    const notif = {
      for: uid,
      from: {
        displayName: dn,
        profilePicture: p ? p : null,
        uid: fuid,
      },
      message: m,
      date: new Date(),
      read: false,
    };
    return this.afs.collection('notifications').add(notif);
  }

  getUserNotifications(uid) {
    return this.afs
      .collection('notifications', (ref) => ref.where('for', '==', uid).orderBy('date', 'desc'))
      .get()
      .pipe(
        map((snapshot) => {
          const items = [];
          snapshot.docs.map((a) => {
            const data = a.data();
            const id = a.id;
            items.push({ id, ...data });
          });
          return items;
        })
      );
  }

  updateNotification(nid, u) {
    return this.afs.doc(`notifications/${nid}`).update(u);
  }

  inviteColleagues(e: Array<any>, dn: string) {
    return this.http.post(`${environment.apiUrl}/invite`, { emails: e, user_name: dn });
  }

  getHowLongAgo(value) {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) {
        return 'Just now';
      }
      const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1,
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          if (counter === 1) {
            return counter + ' ' + i + ' ago'; // singular (1 day ago)
          } else {
            return counter + ' ' + i + 's ago'; // plural (2 days ago)
          }
      }
    }
    return value;
  }

  createNotificationTrigger(notificationData) {
    return this.afs.collection('notification-triggers').add(notificationData);
  }
}
